import deburr from 'lodash.deburr';
import { isString } from './data';
var formatString = function (str) {
    if (!isString(str)) {
        return '';
    }
    var cleanStr = str.toLowerCase().trim();
    return deburr(cleanStr).replace(/\s/g, '');
};
export var searchInString = function (s, search) {
    return formatString(s).includes(formatString(search));
};
//# sourceMappingURL=strings.js.map